import React, { Component, useState, useEffect } from 'react';
import './HostGameView.scss';

export default class SceneIt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            room: props.room,
            players: props.players,
            answer: props.correctAnswer,
            SceneItData: props.SceneItData || ''
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.SceneItData !== this.props.SceneItData) {
            this.setState({ SceneItData: this.props.SceneItData });
        }

        //if (prevProps.correctAnswer !== this.props.correctAnswer) {

        //    const correctAnswer = Array.isArray(this.props.correctAnswer)
        //        ? this.props.correctAnswer.join('')
        //        : this.props.correctAnswer;

        //    this.setState({ answer: correctAnswer });
        //}
    }

    render() {
        return (
            <div className="scene-it-container">
                {this.state.SceneItData && (
                    <img src={this.state.SceneItData} alt="Scene It" className="scene-it-image" />
                )}
                <ConnectFourLetterBox answer={this.props.correctAnswer} showCorrectAnswer={this.props.showCorrectAnswer } />
            </div>
        );
    }
}

const ConnectFourLetterBox = ({ answer, showCorrectAnswer }) => {
    const [splitAnswer, setSplitAnswer] = useState([]);

    useEffect(() => {
        const formattedAnswer = Array.isArray(answer) ? answer.join('') : answer;
        const slicedWord = typeof formattedAnswer === 'string' ? formattedAnswer.split('') : [];
        setSplitAnswer(slicedWord);
        console.log(slicedWord);
    }, [answer]);

    return (
        <div className={`connect-four-letter-box-container ${showCorrectAnswer ? 'show-correct-answer-bounce' : 'CFLB-start'}`}>
            {splitAnswer.map((letter, index) => (
                <div key={index} className={`connect-four-letter ${letter === ' ' ? 'connect-four-space' : ''}`}>
                    {
                        showCorrectAnswer && (
                            <h1>{letter}</h1>
                        )
                    }
                </div>
            ))}
        </div>
    );
};
